/* Nono preview: open desktop mega menus on hover (hover intent), keep click/keyboard/touch access. Own code. */
(() => {
  const OPEN_DELAY = 120, CLOSE_DELAY = 180;
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  let lastPointer = 'mouse';
  document.addEventListener('pointerdown', (e) => { lastPointer = e.pointerType || 'mouse'; }, true);

  const init = () => {
    document.querySelectorAll('.header__inline-menu details.mega-menu, .header__inline-menu details').forEach((details) => {
      if (details.dataset.nonoHover) return;
      details.dataset.nonoHover = '1';
      const item = details.closest('li') || details;
      const summary = details.querySelector('summary');
      let openTimer, closeTimer;
      const closeOthers = () => document.querySelectorAll('.header__inline-menu details[open]').forEach((d) => { if (d !== details) { d.removeAttribute('open'); d.querySelector('summary')?.setAttribute('aria-expanded', 'false'); } });
      const open = () => { if (!details.open) { closeOthers(); details.open = true; summary?.setAttribute('aria-expanded', 'true'); details.dataset.hoverOpened = '1'; } };
      const close = () => { if (details.open) { details.open = false; summary?.setAttribute('aria-expanded', 'false'); } delete details.dataset.hoverOpened; };
      item.addEventListener('mouseenter', () => {
        if (!canHover.matches) return;
        clearTimeout(closeTimer);
        openTimer = setTimeout(open, OPEN_DELAY);
      });
      item.addEventListener('mouseleave', () => {
        if (!canHover.matches) return;
        clearTimeout(openTimer);
        closeTimer = setTimeout(close, CLOSE_DELAY);
      });
      // A mouse click on an already hover-opened menu keeps it open (instead of toggling shut).
      // Keyboard (Enter/Space, event.detail === 0) and touch taps keep the theme's normal toggle.
      summary?.addEventListener('click', (e) => {
        if (canHover.matches && lastPointer === 'mouse' && e.detail > 0 && details.dataset.hoverOpened) { e.preventDefault(); }
      });
      details.addEventListener('keyup', (e) => { if (e.key === 'Escape') { close(); summary?.focus(); } });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
